import { useEffect, useState, useRef } from "react"
import { Link } from "react-router-dom"
import "./RelatedProducts.css"

function RelatedProducts() {
  const [products, setProducts] = useState([])
  const sliderRef = useRef(null)

  useEffect(() => {
    // ✅ FIX: Correct API Link with Full Domain
    fetch("https://data.lacegota.in/wp-json/wc/store/v1/products")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const items = data.slice(0, 8);
          // Triple copy for smooth infinite loop
          setProducts([...items, ...items, ...items]);
        }
      })
      .catch(err => console.error("Slider Fetch Error:", err));
  }, [])

  /* AUTO SLIDER LOGIC FIX */
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider || products.length === 0) return;

    const autoSlide = setInterval(() => {
      slider.scrollBy({ left: 350, behavior: "smooth" });

      // Reset to middle if reached near end
      if (slider.scrollLeft >= (slider.scrollWidth / 3) * 2) {
         slider.scrollTo({ left: slider.scrollWidth / 3, behavior: "instant" });
      }
    }, 4000);

    return () => clearInterval(autoSlide);
  }, [products]);

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  return (
    <div className="amazonSection">
      <h2 className="amazonTitle">Customers who viewed this item also viewed</h2>

      <div className="sliderWrapper">
        <button className="arrow left" onClick={scrollLeft}>‹</button>

        <div className="productSlider" ref={sliderRef}>
          {products.map((p, index) => {
            // ✅ Price Fix Logic
            const price = p.prices?.price ? parseFloat(p.prices.price) / 100 : 0;
            const regular = p.prices?.regular_price ? parseFloat(p.prices.regular_price) / 100 : 0;

            return (
              <Link key={index} to={`/product/${p.slug}`} className="productCard">
                <div className="imgBox">
                  <img src={p.images?.[0]?.src || "/placeholder.jpg"} alt={p.name} />
                </div>
                <p className="title">{p.name}</p>
                
                <div className="rating">
                  <span className="stars">{"⭐".repeat(5)}</span>
                  <span className="count">({p.review_count || 0})</span>
                </div>

                <div className="priceLine">
                  <span className="price">₹{price.toFixed(0)}</span>
                  {regular > price && (
                    <span className="mrp"> M.R.P: ₹{regular.toFixed(0)}</span>
                  )}
                </div>
                <p className="delivery">FREE Delivery in 3-5 days</p>
              </Link>
            )
          })}
        </div>

        <button className="arrow right" onClick={scrollRight}>›</button>
      </div>
    </div>
  )
}

export default RelatedProducts;